/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from 'react';
import 'jspreadsheet-ce/dist/jspreadsheet.css';
import {useTranslation} from "react-i18next";
import DividerWithText from "../../../components/DividerWithText";
import ErrorCard from "../../../components/buttons/ErrorCard";
import {errorCodes} from "../../../enums/ErrorCodeExcel";
import NotInformation from "../../../components/NotInformation";

const CreationErrorsBody = ({mainJRef, jRefList=[], totalErrors, errorsArray, selectedErrorIndex, columnCode}) => {
    const {t} = useTranslation();
    let errorNumber = 1;

    return (
        <>
            <div className='row mt-5'>
                <div className={"col-12 mb-4 px-0"}>
                    <DividerWithText title={mainJRef.name} />
                </div>
                <div className={"col-12"} ref={mainJRef.jRef} />
            </div>

            <div className={"row mt-5"}>
                <div className={"col-12 mb-4 px-0"}>
                    <DividerWithText title={t('ERRORS') +"("+totalErrors+")"} />
                </div>

                {totalErrors > 0 ?
                    <>
                        {errorsArray?.map((errorItem, rowIndex) => (
                            <>
                                {errorItem?.errors?.map((error, errorIndex) => (
                                    <ErrorCard
                                        key={errorIndex}
                                        numero={errorNumber++}
                                        row={(rowIndex) + 9}
                                        column={t(columnCode[error.position])}
                                        error={t(errorCodes[error.errorCode])}
                                        value={error.value}
                                        isSelected={selectedErrorIndex === rowIndex && errorIndex === error.position}
                                    />
                                ))}
                            </>
                        ))}
                    </>
                    :
                    <div className={"col-12 mb-4 px-0"}><NotInformation text={t('no_errors_found')} card={false} /></div>
                }
            </div>

            { jRefList?.map(e => {
                return <div className='row mt-5'>
                    <div className={"col-12 mb-4 px-0"}>
                        <DividerWithText title={e.name} />
                    </div>
                    <div className={"col-12"} ref={e.jRef} />
                </div>
            })
            }
        </>
    );
};

export default CreationErrorsBody;
